const getCompanyHouseIds = (company) => {
  const houseIds = [];

  company.regions.forEach((region) =>
    region.streets.forEach((street) =>
      street.houses.forEach((house) => houseIds.push(house.houseId))
    )
  );

  return houseIds;
};

const getRegionHouseIds = (region) => {
  const houseIds = [];

  region.streets.forEach((street) =>
    street.houses.forEach((house) => houseIds.push(house.houseId))
  );

  return houseIds;
};

const getStreetHouseIds = (street) => {
  const houseIds = [];

  street.houses.forEach((house) => houseIds.push(house.houseId));

  return houseIds;
};

const isChecked = (selectedHouses, houseIds) => {
  const checkedHouses = selectedHouses.filter((house) =>
    houseIds.find((id) => id === house)
  );

  if (checkedHouses.length === houseIds.length) {
    return true;
  }

  return false;
};

const isIndeterminate = (selectedHouses, houseIds) => {
  const checkedHouses = selectedHouses.filter((house) =>
    houseIds.find((id) => id === house)
  );

  if (checkedHouses.length < houseIds.length && checkedHouses.length > 0) {
    return true;
  }

  return false;
};

const handleSelectChange = (
  checked,
  houseIds,
  setFieldsValue,
  setSelectedHouses
) => {
  const newValues = houseIds.reduce((acc, id) => {
    acc[ `addresses[${id}]` ] = checked;
    return acc;
  }, {});

  setFieldsValue(newValues);

  if (checked) {
    const newSelectedHouses = (selectedHouses) => {
      const mySet = new Set([ ...selectedHouses, ...houseIds ]);

      return [ ...mySet ];
    };

    setSelectedHouses(newSelectedHouses);
  } else {
    const newSelectedHouses = (selectedHouses) =>
      selectedHouses.filter(
        (houseId) => !houseIds.find((id) => id === houseId)
      );

    setSelectedHouses(newSelectedHouses);
  }
};

const handleHouseSelectChange = (
  checked,
  houseId,
  setFieldsValue,
  setSelectedHouses
) => {
  setFieldsValue({ [ `addresses[${houseId}]` ]: checked });

  if (checked) {
    const newHouses = (selectedHouses) => [ ...selectedHouses, houseId ];

    setSelectedHouses(newHouses);
  } else {
    const newHouses = (selectedHouses) => selectedHouses.filter((selectedHouse) => selectedHouse !== houseId);

    setSelectedHouses(newHouses);
  }
};

const getHouseObj = (house, selectedHouses, setFieldsValue, setSelectedHouses) => ({
  ...house,
  checked: !!selectedHouses.find((selectedHouse) => selectedHouse === house.houseId),
  onSelectChange(e) {
    const checked = e.target.checked;
    handleHouseSelectChange(
      checked,
      house.houseId,
      setFieldsValue,
      setSelectedHouses
    )
  },
});

const getStreetObj = (street, selectedHouses, setFieldsValue, setSelectedHouses) => ({
  ...street,
  streetHouseIds: getStreetHouseIds(street),
  checked() {
    return isChecked(selectedHouses, this.streetHouseIds);
  },
  indeterminate() {
    return isIndeterminate(selectedHouses, this.streetHouseIds);
  },
  onSelectChange(e) {
    const checked = e.target.checked;
    handleSelectChange(
      checked,
      this.streetHouseIds,
      setFieldsValue,
      setSelectedHouses
    );
  },
  houses: street.houses.map((house) => getHouseObj(
    house,
    selectedHouses,
    setFieldsValue,
    setSelectedHouses
  )),
});

const getRegionObj = (region, selectedHouses, setFieldsValue, setSelectedHouses) => ({
  ...region,
  regionHouseIds: getRegionHouseIds(region),
  checked() {
    return isChecked(selectedHouses, this.regionHouseIds);
  },
  indeterminate() {
    return isIndeterminate(selectedHouses, this.regionHouseIds);
  },
  onSelectChange(e) {
    const checked = e.target.checked;
    handleSelectChange(
      checked,
      this.regionHouseIds,
      setFieldsValue,
      setSelectedHouses
    );
  },
  streets: region.streets.map((street) => getStreetObj(
    street,
    selectedHouses,
    setFieldsValue,
    setSelectedHouses
  )),
});

const getCompanyObj = (company, selectedHouses, setFieldsValue, setSelectedHouses) => ({
  ...company,
  companyHouseIds: getCompanyHouseIds(company),
  checked() {
    return isChecked(selectedHouses, this.companyHouseIds);
  },
  indeterminate() {
    return isIndeterminate(selectedHouses, this.companyHouseIds);
  },
  onSelectChange(e) {
    const checked = e.target.checked;
    handleSelectChange(
      checked,
      this.companyHouseIds,
      setFieldsValue,
      setSelectedHouses
    );
  },
  regions: company.regions.map((region) => getRegionObj(
    region,
    selectedHouses,
    setFieldsValue,
    setSelectedHouses
  ))
});

export const getCompanyPreparedData = (
  addresses,
  selectedHouses,
  setFieldsValue,
  setSelectedHouses
) =>
  addresses.map((company) => getCompanyObj(
    company,
    selectedHouses,
    setFieldsValue,
    setSelectedHouses
  ));

export const getRegionPreparedData = (
  company,
  selectedHouses,
  setFieldsValue,
  setSelectedHouses
) => ({
  ...company,
  regions: company.regions.map((region) => getRegionObj(
    region,
    selectedHouses,
    setFieldsValue,
    setSelectedHouses
  ))
});

export const getHousePreparedData = (
  street,
  selectedHouses,
  setFieldsValue,
  setSelectedHouses
) => ({
  ...street,
  houses: street.houses.map((house) => getHouseObj(
    house,
    selectedHouses,
    setFieldsValue,
    setSelectedHouses
  ))
});
